import React from 'react';
export function InstantAccessSection() {
  const items = [{
    emoji: '📘',
    text: 'I Manuali del Metodo'
  }, {
    emoji: '🤲',
    text: 'Il Manuale delle Firme Artistiche'
  }, {
    emoji: '🗂️',
    text: 'Le Schede Rapide'
  }, {
    emoji: '📓',
    text: 'Registro Allievi & Valutazioni'
  }];
  const previews = ['Manuale del Metodo', 'Sequenze Illustrate', 'Schede Rapide', 'Registro Allievi'];
  return <section className="py-20 px-4 bg-[#f2ebe1]" data-id="element-85">
      <div className="max-w-4xl mx-auto text-center" data-id="element-86">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-12" data-id="element-87">
          📲 Cosa ricevi immediatamente?
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12" data-id="element-88">
          {items.map((item, i) => <div key={i} className="bg-white rounded-2xl p-5 flex items-center justify-center gap-3 shadow-sm border border-white/50" data-id="element-89">
              <span className="text-2xl" data-id="element-90">{item.emoji}</span>
              <span className="font-bold text-brand-text" data-id="element-91">{item.text}</span>
            </div>)}
        </div>

        <p className="text-lg font-serif italic text-brand-green font-bold mb-8" data-id="element-92">
          Guarda il materiale all'interno
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12" data-id="element-93">
          {previews.map((label, i) => <div key={i} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-white/50" data-id="element-94">
              <div className="aspect-[3/4] bg-brand-creamDark flex items-center justify-center text-4xl" data-id="element-95">
                📄
              </div>
              <p className="text-xs font-medium text-brand-gray py-3 px-2" data-id="element-96">
                {label}
              </p>
            </div>)}
        </div>

        <p className="text-2xl font-serif italic text-brand-green font-bold" data-id="element-97">
          Copri il materiale di tutto l'anno
        </p>
      </div>
    </section>;
}